import { round } from 'lodash';
import { VALUE_FONT_SIZE } from '../x-axis/constants';
import { AXIS_LABEL_FONT_SIZE } from './constants';

const PORTAL_Y_AXIS_TICK_DY = 4;

export const getPdfYAxisTickDy = (axisLabelFontSize: number) =>
  round(PORTAL_Y_AXIS_TICK_DY * (axisLabelFontSize / AXIS_LABEL_FONT_SIZE), 2);

const PDF_VALUE_BAND_UP_RATIO = 0.025;

export const getPdfValueTickDy = (
  valueFontSize: number,
  valueRowPixelHeight: number,
) =>
  round(
    valueFontSize * (PORTAL_Y_AXIS_TICK_DY / VALUE_FONT_SIZE) +
      valueRowPixelHeight * PDF_VALUE_BAND_UP_RATIO,
    2,
  );
